
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './FixedSizeImage.icss'
import getImageSrcByResolution from '../utilities/getImageSrcByResolution'

class FixedSizeImage extends React.Component {
	render() {
		const imgSrc = getImageSrcByResolution(this.props)
		return 	(
			<div
				className={classnames(this.props.className, styles.image, (this.props.cover ? styles.cover : null))}
				style={{ backgroundImage: `url(${imgSrc})` }}
			/>
		)
	}
}

FixedSizeImage.propTypes = {
	cover: PropTypes.bool,
	className: PropTypes.string
}

FixedSizeImage.defaultProps = {
	cover: false,
	className: undefined
}

export default FixedSizeImage



// WEBPACK FOOTER //
// ./src/components/FixedSizeImage.jsx